import { GameEvents } from '../../GameEvents';
import { WorldTrigger } from './WorldTrigger';

export class WorldCheckpoint extends WorldTrigger {
  constructor(scene, layer, config) {
    super(scene, layer, { ...config, trigger: GameEvents.CHECKPOINT, destroyOnTrigger: true });
  }
}
